<template>
  <v-col class="pa-0">
    <p class="route-description-text">
      {{ descriptionText }}
    </p>

    <ThemedTextField
      label="Description"
      outlined
      persistent-placeholder
      v-model="descriptionModel"
      class="mt-4"
      dense
    />
    <ThemedCheckbox
      label="Route is verified (will be used as FOA route)"
      class="mt-n4 mb-4 pa-0"
      :ripple="false"
      dense
      v-model="routeIsVerifiedModel"
      :input-value="routeIsVerifiedModel"
    />
  </v-col>
</template>
  
  <script>
import { mapState } from "vuex";
import ThemedTextField from "@/core/ThemedTextField.vue";
import ThemedCheckbox from "@/core/ThemedCheckbox.vue";
export default {
  name: "RouteDescriptionComponent",
  components: { ThemedTextField, ThemedCheckbox },
  data: function () {
    return {};
  },
  computed: {
    ...mapState("weatherRouting/createRouteModule", [
      "routeDescription",
      "routeIsVerified",
    ]),
    descriptionModel: {
      get() {
        return this.routeDescription;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/createRouteModule/SET_ROUTE_DESCRIPTION",
          value,
          { root: true }
        );
      },
    },
    routeIsVerifiedModel: {
      get() {
        return this.routeIsVerified;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/createRouteModule/SET_ROUTE_IS_VERIFIED",
          value,
          { root: true }
        );
      },
    },
    descriptionText() {
      return this.descriptionModel == "" ? "Untitled" : this.descriptionModel;
    },
  },
};
</script>

<style scoped>
.route-description-text {
  font-size: 16px;
  color: var(--color-text);
}
</style>